import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const WrongPath = ({
  statusCode = 404,
  msg = "Page not found",
  link = "/",
  linkText = "Back to Home",
}) => {
  return (
    <main className="grid min-h-full place-items-center dark:dark-bg-back px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-orange-600">{statusCode}</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight dark:dark-text sm:text-5xl">
          {msg}
        </h1>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            to={link}
            className="rounded-md bg-orange-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
          >
            {linkText}
          </Link>
        </div>
      </div>
    </main>
  );
};

export default WrongPath;
